import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type CurrentAdminService from 'garaje/services/current-admin';
import { GLOBAL_ADMIN } from 'garaje/utils/roles';

export default class IntegrationAbility extends Ability {
  @service declare currentAdmin: CurrentAdminService;

  declare model: string;

  /**
   * Almost all of our existing integrations are company wide, which only global admins should be able to install.
   * Only webhooks are location-specific, which both global admins and location admins should be able to install.
   */
  get canInstall(): boolean {
    const { roleNames: roles } = this.currentAdmin;
    return roles.includes(GLOBAL_ADMIN);
  }

  /**
   * Directory integrations (Google Workspace, OneLogin, Okta, Microsoft Entra ID, Delinea)
   * should only be visible to global admins, not location admins.
   */
  get canViewDirectoryIntegrations(): boolean {
    const { roleNames: roles } = this.currentAdmin;
    return roles.includes(GLOBAL_ADMIN);
  }
}
